import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { ContratacionSEACE } from 'src/app/models/ContratacionSEACE';
import { ContratacionHechoIrreg } from 'src/app/models/ContratacionHechoIrreg';
import { MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { DscTituloPaginator, ngClassSalirModal } from 'src/app/general/variables';
import { FichaXConratacionXHi } from 'src/app/models/FichaXContratacionXHi';

@Component({
  selector: 'app-modal-detalle-contratacion',
  templateUrl: './modal-detalle-contratacion.component.html',
  styleUrls: ['./modal-detalle-contratacion.component.css']
})
export class ModalDetalleContratacionComponent implements OnInit {

  contratacionSEACE: ContratacionSEACE = new ContratacionSEACE();
  listaHechoIrregular: FichaXConratacionXHi[] = [];

  ngClassSalirModal = ngClassSalirModal;

  matTableColumnsDef = ['item', 'hechoIrregular'];
  dataSource: MatTableDataSource<FichaXConratacionXHi>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(private dialogRef: MatDialogRef<ModalDetalleContratacionComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2('Detalle de Contrataciones');

    console.log('===========this.data.listaHi');
    console.log(this.data.listaHi);

    this.contratacionSEACE = this.data.contratacion;
    this.listaHechoIrregular = this.data.listaHi;

    this._resetMatTable();

  }

  _resetMatTable() {

    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listaHechoIrregular);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

      // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 1);

  }

  _cancelar() {

    this.dialogRef.close();

  }

}
